{
  "todayButton": "Cегодня",
  "nextMonth": "Следующий месяц",
  "previousMonth": "Прошлый месяц",
  "nextYear": "В следующем году",
  "previousYear": "Предыдущий год",
  "weekdays": [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ],
  "months": [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь"
  ]
}
